<template>
  <div v-if="showBanner" class="banner" :class="classes">
    {{ message }}
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { bannerContent } from "@/config";
export default {
  name: "Banner",
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    message() {
      return bannerContent[this.currencyCode]?.message;
    },
    color() {
      return bannerContent[this.currencyCode]?.color;
    },
    classes() {
      return {
        "banner--white": this.color === "white",
        "banner--black": this.color === "black",
        "banner--red": this.color === "red",
      };
    },
    showBanner() {
      return !!this.message;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  align-items: center;
  display: flex;
  height: 34px;
  @include utility-body(12px);
  justify-content: center;
  letter-spacing: 0.65px;
  text-decoration: none;
  padding: 0 5px;

  &--white {
    background-color: $color-white;
    color: $color-black;
  }

  &--black {
    background-color: $color-black;
    color: $color-white;
  }

  &--red {
    background-color: #d0021b;
    color: $color-white;
  }

  &__link {
    text-decoration: none;
  }

  @include respond-above(md) {
    height: 36px;
  }
}
</style>
